$shm_hitalama_attach $mol_attach
	files? /File
	Add $shm_button_open
		title <= attach_title
		files? <=> attach_new?
